import React from "react";

const AdminAccountInvoker = () => {
    return (
        <li>
            <a href="/admin/my-account">
                <i className="icon-user"/>
                <span className="visible-xs-inline-block position-right">My Account</span>
            </a>
        </li>
    );
};

export default AdminAccountInvoker;
